import React, { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import DateStepInput from '../../../../components/inputs/DateStepInput'
import { getMaxDate, getMinDate } from '../../../../utils/dateUtils'
import { MoveOutFormFields } from '../MoveOutWizard'

interface LastDayOfElecricityUseStepProps {
	form: UseFormReturn<MoveOutFormFields>
}

const LastDayOfElecricityUseStep: FC<LastDayOfElecricityUseStepProps> = ({ form }) => {
	const minDate = getMinDate()
	const maxDate = getMaxDate()
	const { t } = useTranslation('modals_moveOutContact')

	return (
		<DateStepInput<MoveOutFormFields>
			form={form}
			fieldName='lastDayOfElectricityUse'
			minDate={minDate}
			maxDate={maxDate}
			label={t('lastDayOfElectricityStep.lastDayOfElectricity')}
			description={t('lastDayOfElectricityStep.description')}
		/>
	)
}

export default LastDayOfElecricityUseStep
